module.exports = __webpack_public_path__ + "static/media/galerija_2021 (3).bab4b4d8.jpg";